import {
  Cell,
  CellGroup
} from 'vant'

export default {
  components: (() => {
    const obj = {}
    obj[Cell.name] = Cell
    obj[CellGroup.name] = CellGroup
    return obj
  })()
}
